import { requireDashboardOrigin } from "@api/features/dashboard-auth/origin/dashboardOriginGuard"
import { serverRouteConfig } from "@server/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const loginInputSchema = z.object({
  email: z.string().email().max(254),
  password: z.string().min(1).max(128),
})

export const Route = createFileRoute("/api/dashboard/auth/login")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = loginInputSchema.parse(await request.json())
            const { loginDashboardWithPassword } = await import(
              "@api/features/dashboard-auth/dashboardAuthApi"
            )
            const result = await loginDashboardWithPassword(input)
            return Response.json(result.payload, {
              headers: { "Set-Cookie": result.setCookie },
              status: result.status ?? 200,
            })
          } catch (error) {
            return Response.json(
              { error: error instanceof Error ? error.message : "Could not sign in." },
              { status: 401 }
            )
          }
        },
      },
    },
  })
)
